import React, { useRef, useState } from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Button, Popover } from 'antd';
import { connect } from 'react-redux';
import { SettingLink } from 'app/modules/setting/components/setting';
import { LoginLink } from 'app/modules/auth/components/login';
import { RegistrationLink } from 'app/modules/auth/components/registration';
import { fetchLogout } from 'app/modules/auth/actions/postLogout';
import { NavbarItem } from 'app/components/navbar/NavbarItem';
import { NavbarItemMobile } from './navbar/NavbarItemMobile';
import { useClickOutside } from 'app/hooks/useClickOutside';

const UnAuthPopover = ({ onLogin, onRegistration, mobile }) => {
    return (
        <div className={'searchbar-item-popover'}>
            <Button onClick={onLogin} className={mobile && 'mb'}>
                Войти
            </Button>
            <Button onClick={onRegistration}>Регистрация</Button>
        </div>
    );
};

const AuthPopover = ({ onLogout, onSetting, showSetting, mobile }) => {
    return (
        <div className={'searchbar-item-popover'}>
            {showSetting ? (
                <Button onClick={onSetting} className={mobile && 'mb'}>
                    Настройки
                </Button>
            ) : null}
            <Button onClick={onLogout}>Выход</Button>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        points: state.pointsState.points.response.lists,
        user: state.authState.user,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        openSetting: () => {
            dispatch({
                type: 'openRightModal',
                HeadItem: ['Настройки'],
                children: <SettingLink />,
                onClose: () => {
                    dispatch({ type: 'closeRightModal' });
                },
            });
        },
        openLogin: (onAfterLogin) => {
            dispatch({
                type: 'openMiniModal',
                header: 'Вход',
                children: <LoginLink />,
                onClose: () => {
                    dispatch({ type: 'closeMiniModal' });
                },
            });
        },
        openRegistration: () => {
            dispatch({
                type: 'openMiniModal',
                header: 'Регистрация',
                children: <RegistrationLink />,
                onClose: () => {
                    dispatch({ type: 'closeMiniModal' });
                },
            });
        },
        logout: () => dispatch(fetchLogout()),
    };
}

export const ConnectedProfile = connect(
    mapStateToProps,
    mapDispatchToProps
)(
    ({
        user,
        points,
        openSetting,
        openRegistration,
        openLogin,
        logout,
        mobile,
    }) => {
        const Container = mobile ? NavbarItemMobile : NavbarItem;
        const clickRef = useRef();
        const [isModal, setIsModal] = useState(false);
        const onClickOutside = () => setIsModal(false);
        useClickOutside(clickRef, onClickOutside);
        return (
            <div className="position-relative">
                {!mobile ? (
                    <Popover
                        arrow={{ pointAtCenter: true }}
                        content={
                            user ? (
                                <AuthPopover
                                    showSetting={
                                        user.isAdmin &&
                                        (points || points?.length !== 1)
                                    }
                                    onSetting={openSetting}
                                    onLogout={logout}
                                />
                            ) : (
                                <UnAuthPopover
                                    onLogin={openLogin}
                                    onRegistration={openRegistration}
                                />
                            )
                        }
                    >
                        <div>
                            <Container
                                name={user ? 'Профиль' : 'Войти'}
                                icon={<UserOutlined />}
                            />
                        </div>
                    </Popover>
                ) : (
                    <>
                        {isModal && user ? (
                            <AuthPopover
                                showSetting={
                                    user.isAdmin &&
                                    (points || points?.length !== 1)
                                }
                                onSetting={openSetting}
                                onLogout={logout}
                                mobile={mobile}
                            />
                        ) : isModal && !user ? (
                            <UnAuthPopover
                                onLogin={openLogin}
                                onRegistration={openRegistration}
                                mobile={mobile}
                            />
                        ) : null}
                        <Container
                            ref={clickRef}
                            onClick={() => setIsModal(true)}
                            name={user ? 'Профиль' : 'Войти'}
                            icon={<UserOutlined />}
                        />
                    </>
                )}
            </div>
        );
    }
);
